/**
 * Instagram Feed Section
 * Handles the Swiper initialization for mobile slider
 */

if (!customElements.get('w-instagram-feed')) {
  class InstagramFeed extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.swiperContainer = this.querySelector('.instagram-feed-swiper');
    }

    connectedCallback() {
      this.initSwiper();
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      window.removeEventListener('resize', this.handleResize.bind(this));
    }

    initSwiper() {
      if (!this.swiperContainer) return;

      // Only initialize Swiper on mobile
      if (window.innerWidth < 990) {
        if (!this.swiper) {
          this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: false,
            speed: 400,
            watchOverflow: true,
            grabCursor: true,
          });
        }
      } else {
        // Destroy Swiper on desktop
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    handleResize() {
      this.initSwiper();
    }
  }

  customElements.define('w-instagram-feed', InstagramFeed);
}
